const heroSection = $('#hero-section');
const miniMap = heroSection.find('.mini-map-parent');

const headlineStrong = $('.hero-section-title strong');
const imageParent = $('<a class="title-image-parent" href="#map-section"></a>');
imageParent.append(miniMap.clone());
if (isDesktop()) {
  headlineStrong.replaceWith(imageParent);
} else {
  headlineStrong.replaceWith();
}

const addMiniMapIn = () => {
  const miniMapPoint = heroSection.find('.mini-map-point');
  const miniMapTL = gsap.timeline({ paused: true });

  if (isDesktop()) {
    const miniMap = heroSection.find('.title-image-parent');

    miniMapTL.add(
      gsap.fromTo(
        miniMap,
        {
          width: 0,
          marginInline: '-0.55vw',
        },
        {
          width: `6.38vw`,
          marginInline: 0,
          duration: 0.83,
          ease: 'pageInEasing',
        }
      ),
      0
    );
    miniMapTL.add(
      gsap.fromTo(
        miniMap,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.77,
          ease: 'opacityInEasing',
        }
      ),
      0
    );
  }
  miniMapTL.add(
    gsap.fromTo(
      miniMapPoint,
      {
        scale: 0,
      },
      {
        scale: 1,
        duration: 0.63,
        ease: 'pageInEasing',
      }
    ),
    0.55
  );
  return miniMapTL;
};

const addDistributorsHeroIn = () => {
  const animationConfig = {
    offsetPercent: '150',
    opacityStart: 0.9,
    blurStart: '5px',
    duration: 0.9,
    delay: 0,
    stagger: 0.15,
    isDurationCommon: false,
  }

  const heroDescription = heroSection.find('.hero-section-descriptor');
  const heroTitle = heroSection.find('.hero-section-title');
  const heroBtn = heroSection.find('.button-parent');
  const scrollHandler = heroSection.find('.scroll-handle');
  const lineParent = heroSection.find('.hero-line-parent');
  const miniMap = heroSection.find('.mini-map-parent');

  const lineTL = addLoopLineAnimation(lineParent, {
    direction: 'horizontal',
    duration: 5,
    from: 0,
    to: 1,
    ease: '0.0, 0.4, 1.0, 0.6',
    looped: true,
  });

  const heroTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      $(window).trigger('heroReady');
      lineTL.play();
    },
  });

  heroTL.addLabel('step1');
  heroTL.add(addTitleAnimation({element: heroTitle, animationConfig: animationConfig}).play(), 'step1+=0.5');
  heroTL.add(elementInAnimationYWOpacity(heroDescription, '1000%', 0, 1, 0.9, 0.9, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 'step1+=0.5');
  !isDesktop() ? heroTL.add(elementInAnimationYWOpacity(miniMap, '100%', 0, 1, 0.9, 0.9, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 'step1+=0.6') : false;
  heroTL.add(elementInAnimationYWOpacity(scrollHandler, '200%', 0, 1, 0.667, 0.667, 0, 0, 'start', 'pageInEasing', 'pageInEasing').play(), 'step1+=0.95');
  //heroTL.add(addElementInAnimation(heroDescription, '1000%', 0.9, 0).play(), 'step1+=0.5');
  //!isDesktop() ? heroTL.add(addElementInAnimation(miniMap, '100%', 0.9, 0).play(), 'step1+=0.6') : false;
  //heroTL.add(addElementInAnimation(scrollHandler, '200%', 0.667, 0).play(), 'step1+=0.95');
  heroTL.add(addBtnAnimation(heroBtn).play(), 'step1+=1.4');
  heroTL.add(addMiniMapIn().play(), 'step1+=1.88');
  heroTL.add(headerAnimation(true, 0.6, 0.01).play(), 'step1+=2.13');

  return heroTL;
};

$(window).on('load', () => {
  const [nav] = performance.getEntriesByType('navigation');
  const heroInTL = addDistributorsHeroIn();
  pageIn(heroInTL, nav);
});
